const theme = {
  fonts: {
    title: "GillSans",
    text: "'Open Sans', sans-serif"
  },
  colors: {
    lightGrey: "#D4D4D9",
    lightBlue: "#F7FBFC",
    mediumBlue: "#3BA0ED",
    blue: "#005F9C",
    // lightGreen: "#96DCC1",
    lightGreen: "#67C27A",
    green: "#32BF4B",
    background: "#BEDAE2",
    text: "#3A3A3A",
    h1: "#004B92",
    button: "#004B92",
    buttonDisabled: "#DADADA",
    buttonHover: "#000",
    wizardRecapMission: "#00A280",
    wizardRecapVehicle: "#1269A5",
    wizardRecapFuel: "#FFC944",
    wizardRecapLeasing: "#7BC2A1",
    wizardRecapTax: "#399FCC",
    inputBorder: "#D6D6D6",
    inputBackground: "#FCFCFC",
    error: "red"
  },
  query: {
    sm: "576px",
    md: "768px",
    lg: "1024px",
    xl: "1200px",
    xxl: "1440px",
    xxxl: "1640px"
  }
}

export default theme